// AgentResources.jsx
import { useState, useRef, useEffect, useCallback } from "react";

/* ── Icons ── */
const ChevronLeft = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const BoltIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);
const CalendarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#f59e0b"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const CigarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 18h12" />
    <path d="M15 18h2a4 4 0 0 0 0-8h-2" />
    <path d="M17 10V7" />
  </svg>
);
const LayersIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#f59e0b"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12 2 2 7 12 12 22 7 12 2" />
    <polyline points="2 17 12 22 22 17" />
    <polyline points="2 12 12 17 22 12" />
  </svg>
);
const ClipboardIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="9" y="2" width="6" height="4" rx="1" />
    <path d="M8 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2" />
  </svg>
);
const ExpandIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
  </svg>
);
const BarChartIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);
const ClockDotIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" strokeDasharray="4 2" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
const FileIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="12" y2="17" />
  </svg>
);

/* ── Generic Carrier Icon for new carriers ── */
const GenericCarrierIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <path d="M9 8h6M9 12h6M9 16h4" />
  </svg>
);

/* ── Individual carrier icons (branded & generic fallback) ── */
const TransamericaIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="1" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="3" y1="15" x2="21" y2="15" />
    <line x1="9" y1="9" x2="9" y2="21" />
  </svg>
);
const MutualIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 21V8l9-5 9 5v13" />
    <path d="M9 21V12h6v9" />
  </svg>
);
const AmericoIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 3v18M3 12h18" />
    <path d="M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4" />
  </svg>
);
const AetnaIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2l10 20H2L12 2z" />
    <line x1="12" y1="10" x2="12" y2="16" />
  </svg>
);
const LibertyBankersIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <path d="M3 6h18M3 12h18M3 18h18" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const FGIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <path d="M12 2v20M2 12h20" />
    <rect x="4" y="4" width="16" height="16" />
  </svg>
);
const AIGIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
    <path d="M12 8v8M8 12h8" />
  </svg>
);
const AHLIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
  </svg>
);
const RoyalNeighboursIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <path d="M12 2l2.5 7.5L22 9.5l-6 5.5 1.5 7.5L12 18l-5.5 4.5L8 15l-6-5.5 7.5-1L12 2z" />
  </svg>
);
const ForestersIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <path d="M12 3L3 12l9 9 9-9-9-9z" />
    <path d="M12 9v6M9 12h6" />
  </svg>
);
const EthosIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);
const AflacIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6" />
    <path d="M12 3v12M9 9l3-3 3 3" />
  </svg>
);
const SeniorLifeIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <path d="M12 2v20M2 12h20" />
    <circle cx="12" cy="12" r="4" />
  </svg>
);
const SBLIIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4a017"
    strokeWidth="1.5"
  >
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <path d="M8 8h8v8H8z" />
  </svg>
);

/* Helper to map carrier name to Icon component */
const getCarrierIcon = (name) => {
  const nameLower = name.toLowerCase();
  if (nameLower.includes("transamerica") || nameLower.includes("trans america"))
    return TransamericaIcon;
  if (nameLower === "mutual of omaha") return MutualIcon;
  if (nameLower === "americo") return AmericoIcon;
  if (nameLower === "aetna") return AetnaIcon;
  if (nameLower.includes("liberty bankers")) return LibertyBankersIcon;
  if (nameLower === "f&g") return FGIcon;
  if (nameLower.includes("aig") || nameLower.includes("corebridge"))
    return AIGIcon;
  if (nameLower === "ahl") return AHLIcon;
  if (nameLower.includes("royal neighbours")) return RoyalNeighboursIcon;
  if (nameLower.includes("foresters")) return ForestersIcon;
  if (nameLower === "ethos") return EthosIcon;
  if (nameLower === "aflac") return AflacIcon;
  if (nameLower.includes("senior life")) return SeniorLifeIcon;
  if (nameLower === "sbli") return SBLIIcon;
  return GenericCarrierIcon;
};

/* Full carrier list from user request */
const carriers = [
  {
    name: "Trans America Immidate Sol",
    Icon: getCarrierIcon("Trans America Immidate Sol"),
  },
  {
    name: "Trans America FeXpress",
    Icon: getCarrierIcon("Trans America FeXpress"),
  },
  { name: "Senior Life", Icon: getCarrierIcon("Senior Life") },
  { name: "SBLI", Icon: getCarrierIcon("SBLI") },
  { name: "Mutual of Omaha", Icon: getCarrierIcon("Mutual of Omaha") },
  { name: "Liberty Bankers", Icon: getCarrierIcon("Liberty Bankers") },
  { name: "F&G", Icon: getCarrierIcon("F&G") },
  { name: "Americo", Icon: getCarrierIcon("Americo") },
  { name: "AIG-Corebridge", Icon: getCarrierIcon("AIG-Corebridge") },
  { name: "AHL", Icon: getCarrierIcon("AHL") },
  { name: "Royal Neighbours", Icon: getCarrierIcon("Royal Neighbours") },
  {
    name: "Foresters Plan Right",
    Icon: getCarrierIcon("Foresters Plan Right"),
  },
  { name: "Foresters E-app", Icon: getCarrierIcon("Foresters E-app") },
  { name: "Ethos", Icon: getCarrierIcon("Ethos") },
  { name: "Aflac", Icon: getCarrierIcon("Aflac") },
  { name: "Aetna", Icon: getCarrierIcon("Aetna") },
];

const carrierPdfLinks = {
  "Trans America Immidate Sol": {
    weight: "/wc/TRANS AMERICA IMMIDIATE.pdf",
    uw: "/ug/Trans America Immidate Sol.pdf",
    ffl: "/ffl-comp.pdf",
  },

  "Trans America FeXpress": {
    weight: "/wc/TRANS AMERICA FEX XPRESS.pdf",
    uw: "/ug/Transamerica FeXpress.pdf",
    ffl: "/ffl-comp.pdf",
  },

  "Senior Life": {
    weight: "/wc/SENIOR LIFE.pdf",
    uw: "",
    ffl: "/ffl-comp.pdf",
  },

  SBLI: {
    weight: "/wc/SBLI.pdf",
    uw: "",
    ffl: "/ffl-comp.pdf",
  },

  "Mutual of Omaha": {
    weight: "/wc/MUTUAL OF OMAHA.pdf",
    uw: "/ug/Mutual of Omaha.pdf",
    ffl: "/ffl-comp.pdf",
  },

  "Liberty Bankers": {
    weight: "/wc/LIBERTY BANKERS.pdf",
    uw: "",
    ffl: "/ffl-comp.pdf",
  },

  "F&G": {
    weight: "/wc/F&G.pdf",
    uw: "",
    ffl: "/ffl-comp.pdf",
  },

  Americo: {
    weight: "/wc/Americo.pdf",
    uw: "",
    ffl: "/ffl-comp.pdf",
  },

  "AIG-Corebridge": {
    weight: "/wc/AIG-COREBRIGDE.pdf",
    uw: "/ug/AIG-Corebridge.pdf",
    ffl: "/ffl-comp.pdf",
  },

  AHL: {
    weight: "/wc/AHL.pdf",
    uw: "/ug/AHL.pdf",
    ffl: "/ffl-comp.pdf",
  },

  "Royal Neighbours": {
    weight: "",
    uw: "/ug/Royal Neighbours.pdf",
    ffl: "/ffl-comp.pdf",
  },

  "Foresters Plan Right": {
    weight: "",
    uw: "/ug/foresters-plan-right-uw-guide.pdf",
    ffl: "/ffl-comp.pdf",
  },

  "Foresters E-app": {
    weight: "",
    uw: "/ug/Foresters Plan right.pdf",
    ffl: "/ffl-comp.pdf",
  },

  Ethos: {
    weight: "",
    uw: "/ug/Ethos.pdf",
    ffl: "/ffl-comp.pdf",
  },

  Aflac: {
    weight: "",
    uw: "/ug/Aflac.pdf",
    ffl: "/ffl-comp.pdf",
  },

  Aetna: {
    weight: "",
    uw: "/ug/Aetna.pdf",
    ffl: "/ffl-comp.pdf",
  },
};

const cheatSections = [
  {
    icon: <BoltIcon />,
    label: "UNDERWRITING STRENGTHS",
    borderColor: "#d4a017",
    content: (
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: "18px",
        }}
      >
        {[
          "Mutual of Omaha: Best-in-class same day decisioning for clean files.",
          "Transamerica: Aggressive acceptance for elevated high-risk lifestyle factors.",
          "Americo: Simplified e-app interface with instant point-of-sale approval.",
        ].map((t, i) => (
          <li
            key={i}
            style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                background: "#d4a017",
                borderRadius: "1px",
                flexShrink: 0,
                marginTop: "6px",
              }}
            />
            <span
              style={{ fontSize: "15px", color: "#d0c5af", lineHeight: 1.6 }}
            >
              {t}
            </span>
          </li>
        ))}
      </ul>
    ),
  },
  {
    icon: <CalendarIcon />,
    label: "ISSUE AGES",
    borderColor: "#f59e0b",
    content: (
      <div>
        {[
          ["Aetna:", "45 – 89"],
          ["Great Western:", "40 – 85"],
          ["Prosperity:", "50 – 80"],
          ["Americo:", "50 – 85"],
        ].map(([k, v], i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 0",
              borderBottom: i < 3 ? "1px solid #1e2430" : "none",
              fontSize: "15px",
            }}
          >
            <span style={{ color: "#cbc1ab" }}>{k}</span>
            <span
              style={{
                color: "#e0e8f0",
                fontWeight: 500,
                fontFamily: "'DM Mono', monospace",
              }}
            >
              {v}
            </span>
          </div>
        ))}
      </div>
    ),
  },
  {
    icon: <CigarIcon />,
    label: "TOBACCO RULES",
    borderColor: "#d4a017",
    content: (
      <blockquote
        style={{
          margin: 0,
          borderLeft: "3px solid #d4a017",
          paddingLeft: "16px",
          color: "#cbc1ab",
          fontStyle: "italic",
          fontSize: "15px",
          lineHeight: 1.7,
        }}
      >
        Occasional Cigar/Pipe users may qualify for Non-Tobacco rates with
        Carrier X & Y if usage is documented as less than 12 occurrences per
        calendar year.
      </blockquote>
    ),
  },
];

const kpiCards = [
  {
    Icon: BarChartIcon,
    title: "Placement Ratio",
    what: "The percentage of submitted applications that successfully go in-force.",
    why: "High ratios indicate accurate field underwriting and client commitment.",
    how: "Verify health details before submission and secure the first premium immediately.",
  },
  {
    Icon: ClockDotIcon,
    title: "Persistency",
    what: "The measurement of policies remaining active after the first 12-24 months.",
    why: "Long-term business stability depends on selling within the client's actual budget.",
    how: "Regular policy reviews and ensuring the product value is fully understood by the client.",
  },
  {
    Icon: FileIcon,
    title: "First Premium Ratio",
    what: "The rate at which the initial payment is successfully drafted and applied.",
    why: "A policy is not legally active until the first premium is accepted by the carrier.",
    how: "Confirm bank details twice and schedule drafts for dates aligned with the client's income cycle.",
  },
];

const intelligenceChips = [
  "Database Connected",
  "Carrier Library Online",
  "Underwriting Updated",
  "Secure Resources",
  "AI Assisted",
];

const resourceFilters = [
  "All",
  "Carrier Guides",
  "Weight Charts",
  "Comp Guides",
  "UW Manuals",
  "Health",
  "Compliance",
  "Favorites",
];

const normalizeSearch = (value) => value.toLowerCase().trim();

const getResourceCount = (name) => {
  const links = carrierPdfLinks[name] || {};
  return [links.weight, links.uw, links.ffl].filter(Boolean).length;
};

const matchesResourceFilter = (name, activeFilter) => {
  const links = carrierPdfLinks[name] || {};
  if (activeFilter === "Weight Charts") return Boolean(links.weight);
  if (activeFilter === "Carrier Guides" || activeFilter === "UW Manuals")
    return Boolean(links.uw);
  if (activeFilter === "Comp Guides" || activeFilter === "Compliance")
    return Boolean(links.ffl);
  if (activeFilter === "Health") return Boolean(links.weight || links.uw);
  return true;
};

export default function AgentResources() {
  const [activeGraded, setActiveGraded] = useState("LEVEL 100%");
  const [resourceSearch, setResourceSearch] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");
  const scrollContainerRef = useRef(null);
  const [leftDisabled, setLeftDisabled] = useState(true);
  const [rightDisabled, setRightDisabled] = useState(false);

  const filteredCarriers = carriers.filter(({ name }) => {
    const links = carrierPdfLinks[name] || {};
    const haystack = normalizeSearch(
      `${name} ${links.weight || ""} ${links.uw || ""} ${links.ffl || ""}`
    );
    const searchMatches =
      !resourceSearch || haystack.includes(normalizeSearch(resourceSearch));
    return searchMatches && matchesResourceFilter(name, activeFilter);
  });

  const updateScrollButtons = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const scrollLeft = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;
    setLeftDisabled(scrollLeft <= 5);
    setRightDisabled(scrollLeft + 5 >= maxScroll);
  }, []);

  const scrollBy = (direction) => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const card = container.querySelector(".ar-carrier-card");
    if (!card) return;
    const cardWidth = card.offsetWidth;
    const gap = 14; // matches grid gap
    const scrollAmount =
      direction === "left" ? -(cardWidth + gap) : cardWidth + gap;
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    setTimeout(updateScrollButtons, 300); // ensure update after scroll
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    updateScrollButtons();
    container.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);
    return () => {
      container.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, [updateScrollButtons]);

  return (
    <div
      className="ar-intel-root"
      style={{
        minHeight: "100vh",
        color: "#d0dce8",
        fontFamily: "'DM Sans', 'Helvetica Neue', Arial, sans-serif",
        overflowX: "hidden",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }

        .ar-carrier-btn {
          display: block; width: 100%;
          background: #282727;
          border: 1px solid #282727;
          border-radius: 5px;
          padding: 9px 12px;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.1em;
          color: #cbc1ab;
          cursor: pointer;
          font-family: inherit;
          transition: border-color 0.18s, color 0.18s, background 0.18s;
          text-align: center;
        }
        .ar-carrier-btn:hover { border-color: #d4a017; color: #d4a017; background: #1a1808; }

        .ar-nav-btn {
          width: 42px; height: 42px;
          background: transparent;
          border: 1px solid #282727;
          border-radius: 6px;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          color: #d4a017;
          transition: border-color 0.18s, background 0.18s;
          flex-shrink: 0;
        }
        .ar-nav-btn:hover { border-color: #d4a017; background: #1a1808; }
        .ar-nav-btn:disabled { opacity: 0.3; cursor: default; }

        .ar-open-btn {
          background: #d4a017;
          color: #0b0d10;
          border: none;
          padding: 15px 28px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.14em;
          border-radius: 6px;
          cursor: pointer;
          font-family: inherit;
          display: flex; align-items: center; gap: 10px;
          transition: background 0.18s;
        }
        .ar-open-btn:hover { background: #e5b420; }

        .ar-tag {
          background: #2a2a2a;
          border: 1px solid #353535;
          border-radius: 4px;
          padding: 7px 14px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.1em;
          color: #cbc1ab;
          cursor: pointer;
          font-family: inherit;
          transition: all 0.18s;
        }
        .ar-tag.active {
          background: #282727;
          border-color: #d4a017;
          color: #d4a017;
        }
        .ar-tag:hover { border-color: #d4a017; color: #d4a017; }

        .ar-section-head {
          display: flex; align-items: center; gap: 10px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.14em;
          color: #e0e8f0;
          margin-bottom: 14px;
          padding-bottom: 12px;
          border-bottom: 1px solid #282727;
        }

        .ar-carrier-card {
          background: #1c1b1b;
          border: 1px solid #282727;
          border-radius: 10px;
          padding: 22px 18px;
          flex-shrink: 0;
          transition: border-color 0.2s;
          width: 260px;
        }
        .ar-carrier-card:hover { border-color: #d4a017; }

        .ar-kpi-card {
          background: #1c1b1b;
          border: 1px solid #282727;
          border-radius: 10px;
          padding: 24px;
          transition: border-color 0.2s;
        }
        .ar-kpi-card:hover { border-color: #d4a017; }

        /* Horizontal scroll smooth */
        .carrier-scroll-container {
          overflow-x: auto;
          scrollbar-width: thin;
          scrollbar-color: #d4a017 #282727;
          -webkit-overflow-scrolling: touch;
        }
        .carrier-scroll-container::-webkit-scrollbar {
          height: 6px;
        }
        .carrier-scroll-container::-webkit-scrollbar-track {
          background: #282727;
          border-radius: 4px;
        }
        .carrier-scroll-container::-webkit-scrollbar-thumb {
          background: #d4a017;
          border-radius: 4px;
        }
        .carrier-flex-track {
          display: flex;
          gap: 14px;
          width: max-content;
        }

        @media (max-width: 640px) {
          .ar-cheat-grid { grid-template-columns: 1fr !important; }
          .ar-kpi-grid { grid-template-columns: 1fr !important; }
          .ar-placement-grid { grid-template-columns: 1fr !important; }
          .ar-health-inner { flex-direction: column !important; }
          .ar-health-img { width: 100% !important; min-height: 180px !important; }
          .ar-carrier-card { width: 240px; }
        }
        @media (max-width: 900px) {
          .ar-kpi-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 540px) {
          .ar-kpi-grid { grid-template-columns: 1fr !important; }
        }
        .ar-intel-root {
          position: relative;
          isolation: isolate;
          background:
            radial-gradient(circle at 12% 8%, rgba(0, 221, 255, 0.16), transparent 28%),
            radial-gradient(circle at 84% 18%, rgba(212, 160, 23, 0.13), transparent 30%),
            linear-gradient(145deg, #061014 0%, #0a151b 48%, #050609 100%) !important;
        }
        .ar-intel-root::before,
        .ar-intel-root::after {
          content: "";
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: -1;
        }
        .ar-intel-root::before {
          opacity: 0.25;
          background-image:
            linear-gradient(rgba(75, 224, 255, 0.09) 1px, transparent 1px),
            linear-gradient(90deg, rgba(75, 224, 255, 0.09) 1px, transparent 1px);
          background-size: 44px 44px;
          mask-image: linear-gradient(to bottom, rgba(0,0,0,0.94), rgba(0,0,0,0.18));
          animation: ar-grid-drift 18s linear infinite;
        }
        .ar-intel-root::after {
          opacity: 0.17;
          background:
            linear-gradient(180deg, transparent 0%, rgba(0, 221, 255, 0.12) 48%, transparent 52%),
            radial-gradient(circle at 72% 76%, rgba(0, 221, 255, 0.18), transparent 24%);
          background-size: 100% 280px, 100% 100%;
          animation: ar-scan 8s ease-in-out infinite;
        }
        .ar-shell {
          position: relative;
          z-index: 1;
          width: 100%;
          max-width: 1500px;
          margin: 0 auto;
          padding: clamp(20px, 3vw, 44px);
        }
        .ar-hero {
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(75, 224, 255, 0.24);
          border-radius: 20px;
          padding: clamp(24px, 4.2vw, 48px);
          background:
            linear-gradient(135deg, rgba(10, 27, 34, 0.93), rgba(8, 14, 20, 0.72)),
            radial-gradient(circle at 82% 18%, rgba(212, 160, 23, 0.16), transparent 28%);
          box-shadow:
            0 26px 80px rgba(0, 0, 0, 0.38),
            inset 0 1px 0 rgba(255, 255, 255, 0.08),
            0 0 34px rgba(0, 221, 255, 0.08);
          animation: ar-card-in 520ms ease both;
        }
        .ar-hero::before {
          content: "";
          position: absolute;
          inset: -42%;
          background: conic-gradient(from 120deg, transparent, rgba(0, 221, 255, 0.16), transparent, rgba(212, 160, 23, 0.14), transparent);
          opacity: 0.42;
          animation: ar-mesh 14s linear infinite;
        }
        .ar-hero > * { position: relative; z-index: 1; }
        .ar-hero-grid {
          display: grid;
          grid-template-columns: minmax(0, 1fr) auto;
          gap: 24px;
          align-items: end;
        }
        .ar-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 14px;
          color: #d4a017;
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.2em;
          text-transform: uppercase;
        }
        .ar-eyebrow span,
        .ar-status-chip span,
        .ar-resource-status::before {
          width: 8px;
          height: 8px;
          border-radius: 999px;
          background: #34f6a5;
          box-shadow: 0 0 14px rgba(52, 246, 165, 0.8);
          animation: ar-pulse 1.9s ease-in-out infinite;
          content: "";
        }
        .ar-hero h1 {
          margin: 0;
          max-width: 980px;
          color: #f8fbff;
          font-size: clamp(32px, 5vw, 70px);
          line-height: 0.94;
          letter-spacing: 0.035em;
          text-transform: uppercase;
          text-shadow: 0 0 34px rgba(0, 221, 255, 0.22);
          animation: ar-title-glow 3.8s ease-in-out infinite;
        }
        .ar-hero p {
          max-width: 760px;
          margin: 16px 0 0;
          color: rgba(224, 239, 255, 0.74);
          font-size: clamp(14px, 1.3vw, 16px);
          line-height: 1.65;
        }
        .ar-hero-metric {
          min-width: 170px;
          padding: 18px;
          border-radius: 16px;
          border: 1px solid rgba(212, 160, 23, 0.28);
          background: rgba(4, 9, 13, 0.48);
          box-shadow: inset 0 0 26px rgba(212, 160, 23, 0.07);
          text-align: right;
        }
        .ar-hero-metric strong {
          display: block;
          color: #d4a017;
          font-family: 'DM Mono', monospace;
          font-size: clamp(34px, 4vw, 54px);
          line-height: 1;
        }
        .ar-hero-metric span {
          color: rgba(240, 247, 255, 0.58);
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
        }
        .ar-status-strip,
        .ar-filter-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .ar-status-strip { margin-top: 28px; }
        .ar-status-chip {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          min-height: 34px;
          padding: 8px 12px;
          border: 1px solid rgba(75, 224, 255, 0.18);
          border-radius: 999px;
          background: rgba(5, 18, 24, 0.66);
          color: rgba(228, 249, 255, 0.78);
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }
        .ar-controls {
          display: grid;
          gap: 16px;
          margin: clamp(22px, 3vw, 34px) 0;
        }
        .ar-search-wrap { position: relative; }
        .ar-search-label {
          position: absolute;
          left: 18px;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(75, 224, 255, 0.78);
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          filter: drop-shadow(0 0 10px rgba(75, 224, 255, 0.36));
        }
        .ar-search-input {
          width: 100%;
          min-height: 58px;
          border: 1px solid rgba(75, 224, 255, 0.2);
          border-radius: 16px;
          padding: 0 58px 0 92px;
          outline: none;
          background: rgba(4, 12, 17, 0.72);
          color: #eef8ff;
          font: inherit;
          font-size: 14px;
          letter-spacing: 0.04em;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 14px 44px rgba(0,0,0,0.24);
          transition: border-color 220ms ease, box-shadow 220ms ease, background 220ms ease;
        }
        .ar-search-input::placeholder { color: rgba(217, 234, 245, 0.42); }
        .ar-search-input:focus {
          border-color: rgba(75, 224, 255, 0.62);
          background: rgba(4, 16, 22, 0.9);
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.08), 0 0 0 4px rgba(75,224,255,0.08), 0 0 36px rgba(75,224,255,0.12);
        }
        .ar-clear-btn {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          width: 34px;
          height: 34px;
          border: 1px solid rgba(212, 160, 23, 0.22);
          border-radius: 999px;
          background: rgba(212, 160, 23, 0.08);
          color: #d4a017;
          cursor: pointer;
        }
        .ar-filter-pill {
          min-height: 36px;
          padding: 0 14px;
          border: 1px solid rgba(75, 224, 255, 0.15);
          border-radius: 999px;
          background: rgba(6, 18, 24, 0.7);
          color: rgba(219, 244, 255, 0.62);
          cursor: pointer;
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.08em;
          transition: transform 180ms ease, color 180ms ease, border-color 180ms ease, background 180ms ease, box-shadow 180ms ease;
        }
        .ar-filter-pill:hover {
          transform: translateY(-2px);
          color: #e9fbff;
          border-color: rgba(75, 224, 255, 0.58);
          box-shadow: 0 0 20px rgba(75, 224, 255, 0.16);
        }
        .ar-filter-pill.active {
          color: #091015;
          border-color: rgba(212, 160, 23, 0.78);
          background: linear-gradient(135deg, #d4a017, #f1c54e);
          box-shadow: 0 0 24px rgba(212, 160, 23, 0.26);
        }
        .ar-section { margin-top: clamp(22px, 3vw, 36px); }
        .ar-section-title {
          display: flex;
          align-items: end;
          justify-content: space-between;
          gap: 16px;
          margin-bottom: 18px;
          color: rgba(228, 249, 255, 0.62);
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
        }
        .ar-section-title strong { color: #d4a017; }
        .ar-carrier-card,
        .ar-glass-card {
          position: relative;
          overflow: hidden;
          background: linear-gradient(145deg, rgba(13, 30, 39, 0.84), rgba(6, 12, 17, 0.76)) !important;
          border: 1px solid rgba(75, 224, 255, 0.18) !important;
          border-radius: 18px !important;
          box-shadow: 0 18px 48px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.06);
          transition: transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease, background 220ms ease;
          animation: ar-card-in 520ms ease both;
        }
        .ar-carrier-card { width: 270px; min-height: 310px; }
        .ar-carrier-card:hover,
        .ar-glass-card:hover,
        .ar-kpi-card:hover {
          transform: translateY(-5px);
          border-color: rgba(75, 224, 255, 0.42) !important;
          box-shadow: 0 24px 70px rgba(0,0,0,0.36), 0 0 28px rgba(75,224,255,0.12), inset 0 1px 0 rgba(255,255,255,0.09);
        }
        .ar-card-icon {
          width: 50px;
          height: 50px;
          border: 1px solid rgba(75, 224, 255, 0.35);
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: radial-gradient(circle at 50% 20%, rgba(75,224,255,0.25), transparent 54%), rgba(0,221,255,0.08);
          box-shadow: 0 0 24px rgba(75,224,255,0.14), inset 0 0 18px rgba(75,224,255,0.08);
        }
        .ar-card-meta {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          margin: 18px 0;
        }
        .ar-card-meta span {
          display: block;
          padding: 9px 10px;
          border: 1px solid rgba(75, 224, 255, 0.12);
          border-radius: 12px;
          background: rgba(4, 12, 17, 0.54);
          color: rgba(228, 249, 255, 0.62);
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }
        .ar-card-meta strong {
          display: block;
          color: #f8fbff;
          font-size: 14px;
          margin-top: 4px;
        }
        .ar-resource-status {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          color: #34f6a5;
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin-top: 6px;
        }
        .ar-carrier-btn {
          position: relative;
          overflow: hidden;
          background: rgba(5, 18, 24, 0.74) !important;
          border: 1px solid rgba(75, 224, 255, 0.2) !important;
          border-radius: 12px !important;
          color: rgba(234, 249, 255, 0.82) !important;
          font-family: 'DM Mono', monospace !important;
          transition: transform 180ms ease, border-color 180ms ease, color 180ms ease, background 180ms ease, box-shadow 180ms ease !important;
        }
        .ar-carrier-btn:hover {
          transform: translateY(-2px);
          border-color: rgba(75, 224, 255, 0.62) !important;
          color: #f8fbff !important;
          background: rgba(0, 221, 255, 0.09) !important;
          box-shadow: 0 0 18px rgba(75, 224, 255, 0.13);
        }
        .ar-open-btn {
          overflow: hidden;
          background: linear-gradient(135deg, #d4a017, #f2c64f) !important;
          border: 1px solid rgba(212, 160, 23, 0.56) !important;
          border-radius: 14px !important;
          font-family: 'DM Mono', monospace !important;
          box-shadow: 0 18px 42px rgba(212,160,23,0.2), inset 0 1px 0 rgba(255,255,255,0.24);
          transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease !important;
        }
        .ar-open-btn:hover {
          transform: scale(1.02);
          filter: brightness(1.05);
          box-shadow: 0 20px 48px rgba(212,160,23,0.32), 0 0 24px rgba(212,160,23,0.18), inset 0 1px 0 rgba(255,255,255,0.32);
        }
        .ar-widget-grid {
          display: grid;
          grid-template-columns: repeat(5, minmax(160px, 1fr));
          gap: 14px;
          margin-top: clamp(22px, 3vw, 34px);
        }
        .ar-widget { min-height: 126px; padding: 18px; }
        .ar-widget span {
          display: block;
          color: rgba(75, 224, 255, 0.64);
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin-bottom: 10px;
        }
        .ar-widget strong {
          display: block;
          color: #f8fbff;
          font-size: 18px;
          line-height: 1.25;
        }
        .ar-widget small {
          display: block;
          margin-top: 10px;
          color: rgba(224, 239, 255, 0.5);
          line-height: 1.5;
        }
        .ar-health-panel {
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(75, 224, 255, 0.2);
          border-radius: 22px;
          background: radial-gradient(circle at 78% 22%, rgba(52,246,165,0.14), transparent 28%), linear-gradient(145deg, rgba(12,30,37,0.9), rgba(6,12,17,0.8));
          box-shadow: 0 24px 72px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.07);
        }
        .ar-health-visual {
          position: relative;
          min-height: 260px;
          border: 1px solid rgba(75, 224, 255, 0.18) !important;
          border-radius: 18px !important;
          background:
            radial-gradient(circle at 50% 50%, rgba(52,246,165,0.24), transparent 30%),
            linear-gradient(rgba(75,224,255,0.09) 1px, transparent 1px),
            linear-gradient(90deg, rgba(75,224,255,0.09) 1px, transparent 1px),
            rgba(3,12,16,0.76) !important;
          background-size: 100% 100%, 28px 28px, 28px 28px, 100% 100% !important;
          display: grid !important;
          place-items: center;
          overflow: hidden;
        }
        .ar-health-visual::before {
          content: "";
          width: 124px;
          height: 124px;
          border: 1px solid rgba(52, 246, 165, 0.5);
          border-radius: 999px;
          box-shadow: 0 0 40px rgba(52, 246, 165, 0.18), inset 0 0 30px rgba(52, 246, 165, 0.1);
          animation: ar-orbit 5s linear infinite;
        }
        .ar-health-visual span {
          position: absolute;
          color: rgba(228, 249, 255, 0.66) !important;
          font-family: 'DM Mono', monospace;
          font-size: 11px !important;
          font-weight: 700 !important;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        .ar-stat-row {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 10px;
          margin: 24px 0;
        }
        .ar-stat-row div {
          border: 1px solid rgba(75, 224, 255, 0.14);
          border-radius: 14px;
          padding: 12px;
          background: rgba(4, 12, 17, 0.52);
        }
        .ar-stat-row span {
          display: block;
          color: rgba(224, 239, 255, 0.52);
          font-family: 'DM Mono', monospace;
          font-size: 9px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin-bottom: 6px;
        }
        .ar-stat-row strong { color: #f8fbff; font-size: 15px; }
        .ar-cheat-card { min-height: 100%; padding: 22px; }
        .ar-kpi-card {
          background: linear-gradient(145deg, rgba(13, 30, 39, 0.8), rgba(6, 12, 17, 0.7)) !important;
          border: 1px solid rgba(75, 224, 255, 0.17) !important;
          border-radius: 18px !important;
        }
        .ar-placement-copy-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 18px;
        }
        .ar-placement-copy-grid p {
          border: 1px solid rgba(75, 224, 255, 0.13);
          border-radius: 16px;
          background: rgba(4, 12, 17, 0.48);
          padding: 16px;
        }
        .ar-empty {
          min-height: 180px;
          display: grid;
          place-items: center;
          border: 1px dashed rgba(75, 224, 255, 0.2);
          border-radius: 18px;
          color: rgba(224, 239, 255, 0.45);
          background: rgba(4, 12, 17, 0.38);
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        @keyframes ar-card-in {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes ar-grid-drift {
          from { background-position: 0 0; }
          to { background-position: 44px 44px; }
        }
        @keyframes ar-scan {
          0%, 100% { background-position: 0 -280px, 0 0; }
          50% { background-position: 0 100vh, 0 0; }
        }
        @keyframes ar-mesh {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes ar-pulse {
          0%, 100% { opacity: 0.72; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.16); }
        }
        @keyframes ar-title-glow {
          0%, 100% { text-shadow: 0 0 26px rgba(0, 221, 255, 0.18); }
          50% { text-shadow: 0 0 42px rgba(0, 221, 255, 0.32); }
        }
        @keyframes ar-orbit {
          from { transform: rotate(0deg) scale(1); }
          to { transform: rotate(360deg) scale(1); }
        }
        @media (max-width: 900px) {
          .ar-hero-grid { grid-template-columns: 1fr; }
          .ar-hero-metric { width: fit-content; text-align: left; }
          .ar-widget-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .ar-stat-row { grid-template-columns: 1fr; }
        }
        @media (max-width: 640px) {
          .ar-shell { padding: 18px 14px 28px; }
          .ar-hero { padding: 22px 16px; border-radius: 16px; }
          .ar-status-chip { width: 100%; }
          .ar-widget-grid { grid-template-columns: 1fr; }
          .ar-placement-copy-grid { grid-template-columns: 1fr; }
          .ar-search-label { display: none; }
          .ar-search-input { padding-left: 18px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ar-intel-root::before,
          .ar-intel-root::after,
          .ar-hero::before,
          .ar-eyebrow span,
          .ar-status-chip span,
          .ar-resource-status::before,
          .ar-health-visual::before,
          .ar-hero h1,
          .ar-carrier-card,
          .ar-glass-card {
            animation: none !important;
          }
          .ar-carrier-card,
          .ar-glass-card,
          .ar-carrier-btn,
          .ar-open-btn,
          .ar-filter-pill,
          .ar-nav-btn,
          .ar-kpi-card {
            transition: none !important;
          }
        }
      `}</style>

      {/* ── Header ── */}
      <main className="ar-shell">
        <section className="ar-hero" aria-labelledby="agent-resources-title">
          <div className="ar-hero-grid">
            <div>
              <div className="ar-eyebrow">
                <span />
                Enterprise Knowledge Core
              </div>
              <h1 id="agent-resources-title">Agent Intelligence Center</h1>
              <p>
                Verified underwriting resources, carrier guides, field tools,
                and agency intelligence.
              </p>
            </div>
            <div className="ar-hero-metric">
              <strong>{carriers.length}</strong>
              <span>Carrier Modules</span>
            </div>
          </div>
          <div className="ar-status-strip">
            {intelligenceChips.map((chip) => (
              <span className="ar-status-chip" key={chip}>
                <span />
                {chip}
              </span>
            ))}
          </div>
        </section>

        <section className="ar-controls" aria-label="Resource search and filters">
          <div className="ar-search-wrap">
            <span className="ar-search-label">Search</span>
            <input
              className="ar-search-input"
              value={resourceSearch}
              onChange={(event) => setResourceSearch(event.target.value)}
              placeholder="Search carriers... Search guides... Search underwriting..."
              aria-label="Search resources"
            />
            {resourceSearch && (
              <button
                type="button"
                className="ar-clear-btn"
                onClick={() => setResourceSearch("")}
                aria-label="Clear search"
              >
                X
              </button>
            )}
          </div>

          <div className="ar-filter-row" aria-label="Resource filters">
            {resourceFilters.map((filter) => (
              <button
                key={filter}
                type="button"
                className={`ar-filter-pill${
                  activeFilter === filter ? " active" : ""
                }`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>
        </section>

        <section className="ar-widget-grid" aria-label="Quick reference panels">
          <div className="ar-widget ar-glass-card">
            <span>Most Used Carrier</span>
            <strong>Mutual of Omaha</strong>
            <small>Quick underwriting reference available.</small>
          </div>
          <div className="ar-widget ar-glass-card">
            <span>Recently Opened</span>
            <strong>Health Matrix</strong>
            <small>Central condition routing reference.</small>
          </div>
          <div className="ar-widget ar-glass-card">
            <span>Recently Updated</span>
            <strong>Carrier Guides</strong>
            <small>Verified library status is online.</small>
          </div>
          <div className="ar-widget ar-glass-card">
            <span>Favorite Carriers</span>
            <strong>Primary Set</strong>
            <small>Use filters to narrow resources fast.</small>
          </div>
          <div className="ar-widget ar-glass-card">
            <span>Frequent Charts</span>
            <strong>Weight Charts</strong>
            <small>Carrier-specific PDF links preserved.</small>
          </div>
        </section>

      {/* ── QUICK ACCESS CARRIER RESOURCES (Smooth Scroll Carousel) ── */}
      <section className="ar-section">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "24px",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <span className="ar-section-title" style={{ marginBottom: 0 }}>
            Resource Carousel / <strong>{filteredCarriers.length}</strong>{" "}
            modules visible
          </span>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              className="ar-nav-btn"
              onClick={() => scrollBy("left")}
              disabled={leftDisabled}
            >
              <ChevronLeft />
            </button>
            <button
              className="ar-nav-btn"
              onClick={() => scrollBy("right")}
              disabled={rightDisabled}
            >
              <ChevronRight />
            </button>
          </div>
        </div>

        <div className="carrier-scroll-container" ref={scrollContainerRef}>
          <div className="carrier-flex-track">
            {filteredCarriers.map(({ name, Icon }, index) => (
              <div
                key={name}
                className="ar-carrier-card"
                style={{ animationDelay: `${Math.min(index, 16) * 42}ms` }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    marginBottom: "20px",
                  }}
                >
                  <div className="ar-card-icon">
                    <Icon />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <span
                      style={{
                        display: "block",
                        fontSize: "16px",
                        fontWeight: 700,
                        color: "#f8fbff",
                        lineHeight: 1.25,
                      }}
                    >
                      {name}
                    </span>
                    <span className="ar-resource-status">Online</span>
                  </div>
                </div>
                <div className="ar-card-meta">
                  <span>
                    Resources
                    <strong>{getResourceCount(name)}</strong>
                  </span>
                  <span>
                    Updated
                    <strong>Live</strong>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  {carrierPdfLinks[name]?.weight && (
                    <button
                      className="ar-carrier-btn"
                      onClick={() =>
                        window.open(carrierPdfLinks[name].weight, "_blank")
                      }
                    >
                      WEIGHT CHART
                    </button>
                  )}

                  {carrierPdfLinks[name]?.uw && (
                    <button
                      className="ar-carrier-btn"
                      onClick={() =>
                        window.open(carrierPdfLinks[name].uw, "_blank")
                      }
                    >
                      UW GUIDE
                    </button>
                  )}

                  {carrierPdfLinks[name]?.ffl && (
                    <button
                      className="ar-carrier-btn"
                      onClick={() =>
                        window.open(carrierPdfLinks[name].ffl, "_blank")
                      }
                    >
                      COMP GUIDE
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        {filteredCarriers.length === 0 && (
          <div className="ar-empty">No resources match the current search.</div>
        )}
      </section>

      {/* ── Common Health Matrix (unchanged) ── */}
      <section
        className="ar-section ar-health-panel"
        style={{
          marginBottom: "40px",
        }}
      >
        <div
          style={{ padding: "clamp(24px, 4vw, 44px)" }}
        >
          <div
            className="ar-health-inner"
            style={{ display: "flex", gap: "40px", alignItems: "center" }}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <h2
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  letterSpacing: "0.06em",
                  color: "#f0f4f8",
                  marginBottom: "16px",
                }}
              >
                COMMON HEALTH MATRIX
              </h2>
              <p
                style={{
                  fontSize: "15px",
                  color: "#d0c5af",
                  lineHeight: 1.7,
                  marginBottom: "28px",
                }}
              >
                Access the comprehensive tactical matrix for standard health
                impairments. This reference guide provides immediate eligibility
                feedback across all primary carriers.
              </p>
              <div className="ar-stat-row">
                <div>
                  <span>Supported Carriers</span>
                  <strong>{carriers.length}</strong>
                </div>
                <div>
                  <span>Updated Date</span>
                  <strong>Live</strong>
                </div>
                <div>
                  <span>Conditions Covered</span>
                  <strong>Matrix</strong>
                </div>
              </div>
              <button
                onClick={() => window.open("/health-grid.pdf", "_blank")}
                className="ar-open-btn"
              >
                <ExpandIcon />
                <span>OPEN HEALTH MATRIX</span>
              </button>
            </div>
            <div
              className="ar-health-img ar-health-visual"
              style={{
                width: "380px",
                flexShrink: 0,
              }}
            >
              <span
                style={{ fontSize: "13px", color: "#7b7b7a", fontWeight: 500 }}
              >
                Medical Intelligence Preview
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ── Carrier Cheat Sheet (unchanged) ── */}
      <section
        className="ar-section"
        style={{
          marginBottom: "40px",
        }}
      >
        <div
          style={{ padding: "clamp(24px, 4vw, 44px) 0" }}
        >
          <div style={{ marginBottom: "36px" }}>
            <h2
              style={{
                fontSize: "20px",
                fontWeight: 700,
                letterSpacing: "0.06em",
                color: "#f0f4f8",
                marginBottom: "8px",
              }}
            >
              CARRIER CHEAT SHEET
            </h2>
            <p
              style={{
                fontSize: "11px",
                fontWeight: 600,
                letterSpacing: "0.16em",
                color: "#676565",
              }}
            >
              TACTICAL REFERENCE // INTERNAL USE ONLY
            </p>
          </div>

          <div
            className="ar-cheat-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "32px",
              marginBottom: "40px",
            }}
          >
            {cheatSections.map(({ icon, label, borderColor, content }) => (
              <div key={label} className="ar-cheat-card ar-glass-card">
                <div
                  className="ar-section-head"
                  style={{ borderBottomColor: borderColor }}
                >
                  {icon}
                  <span>{label}</span>
                </div>
                {content}
              </div>
            ))}
          </div>

          <div
            className="ar-placement-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 2fr",
              gap: "40px",
            }}
          >
            <div>
              <div
                className="ar-section-head"
                style={{ borderBottomColor: "#f59e0b" }}
              >
                <LayersIcon />
                <span>GRADED VS LEVEL</span>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  flexWrap: "wrap",
                  marginTop: "8px",
                }}
              >
                {["LEVEL 100%", "GRADED 2YR", "MODIFIED 3YR"].map((tag) => (
                  <button
                    key={tag}
                    className={`ar-tag${activeGraded === tag ? " active" : ""}`}
                    onClick={() => setActiveGraded(tag)}
                  >
                    {tag}
                  </button>
                ))}
              </div>
              <div
                style={{
                  marginTop: "20px",
                  fontSize: "14px",
                  color: "#676565",
                  lineHeight: 1.6,
                }}
              >
                {activeGraded === "LEVEL 100%" &&
                  "Full face amount paid from day one. Best option for clients in good health with straightforward underwriting."}
                {activeGraded === "GRADED 2YR" &&
                  "Partial benefit in years 1-2 (usually 30-70%), then 100% from year 3. Common for higher-risk clients."}
                {activeGraded === "MODIFIED 3YR" &&
                  "Return of premium + interest only for years 1-3, then full benefit. Suitable for declined or impaired risk."}
              </div>
            </div>

            <div>
              <div
                className="ar-section-head"
                style={{ borderBottomColor: "#d4a017" }}
              >
                <ClipboardIcon />
                <span>PLACEMENT NOTES</span>
              </div>
              <div
                className="ar-placement-copy-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "18px",
                  marginTop: "8px",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    color: "#d0c5af",
                    lineHeight: 1.7,
                  }}
                >
                  Heavy lean towards MIB records for psychiatric history.
                  Verification of pharmacy records is standard across all Tier 1
                  carriers. Avoid Carrier Z for bipolar history diagnosed within
                  24 months.
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#d0c5af",
                    lineHeight: 1.7,
                  }}
                >
                  For clients with dual-health conditions (e.g. Diabetes +
                  Cardiac), always prioritize Carriers with independent
                  impairment weighting to avoid cumulative decline.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── KPI Education (unchanged) ── */}
      <section className="ar-section" style={{ paddingBottom: "24px" }}>
        <div style={{ marginBottom: "28px" }}>
          <span
            style={{
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.18em",
              color: "#d4a017",
            }}
          >
            KPI EDUCATION // FIELD FUNDAMENTALS
          </span>
        </div>
        <div
          className="ar-kpi-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "16px",
          }}
        >
          {kpiCards.map(({ Icon, title, what, why, how }) => (
            <div key={title} className="ar-kpi-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    background: "#0d1218",
                    border: "1px solid #282727",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon />
                </div>
                <span
                  style={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#e0e8f0",
                  }}
                >
                  {title}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    color: "#d0c5af",
                    lineHeight: 1.6,
                  }}
                >
                  <span style={{ fontWeight: 600, color: "#ffffff" }}>
                    What it is:{" "}
                  </span>
                  {what}
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#d0c5af",
                    lineHeight: 1.6,
                  }}
                >
                  <span style={{ fontWeight: 600, color: "#ffffff" }}>
                    Why it matters:{" "}
                  </span>
                  {why}
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#d0c5af",
                    lineHeight: 1.6,
                  }}
                >
                  <span style={{ fontWeight: 600, color: "#ffffff" }}>
                    How to protect:{" "}
                  </span>
                  {how}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
      </main>
    </div>
  );
}
